import { Component, Input, ElementRef } from '@angular/core';

@Component({
  selector: 'uex-media-right',
  templateUrl: './right.component.html',
  host: {
    class: 'uex-media-right media-right',

    '[hidden]': '!hasContent()',
    '[class.d-flex]': 'hasContent()',

    '[class.align-self-start]': 'alignSelf == \'start\'',
    '[class.align-self-center]': 'alignSelf == \'center\'',
    '[class.align-self-end]': 'alignSelf == \'end\'',
    '[class.align-self-baseline]': 'alignSelf == \'baseline\'',
    '[class.align-self-stretch]': 'alignSelf == \'stretch\'',

    '[class.align-items-start]': 'alignItems == \'start\'',
    '[class.align-items-center]': 'alignItems == \'center\'',
    '[class.align-items-end]': 'alignItems == \'end\'',
    '[class.align-items-baseline]': 'alignItems == \'baseline\'',
    '[class.align-items-stretch]': 'alignItems == \'stretch\'',

    '[class.align-content-start]': 'alignContent == \'start\'',
    '[class.align-content-center]': 'alignContent == \'center\'',
    '[class.align-content-end]': 'alignContent == \'end\'',
    '[class.align-content-between]': 'alignContent == \'between\'',
    '[class.align-content-around]': 'alignContent == \'around\'',
    '[class.align-content-stretch]': 'alignContent == \'stretch\'',

    '[class.justify-content-start]': 'justifyItems == \'start\'',
    '[class.justify-content-center]': 'justifyItems == \'center\'',
    '[class.justify-content-end]': 'justifyItems == \'end\'',
    '[class.justify-content-between]': 'justifyItems == \'between\'',
    '[class.justify-content-around]': 'justifyItems == \'around\'',
    '[class.justify-content-stretch]': 'justifyItems == \'stretch\''
  }
})
export class MediaRightComponent {
  @Input('alignSelf') public alignSelf: string = null;
  @Input('alignItems') public alignItems = 'start';
  @Input('alignContent') public alignContent: string = null;
  @Input('justifyItems') public justifyItems: string = null;

  constructor(
    public elementRef: ElementRef
  ) { }

  public hasContent(): boolean {
    const child_nodes = this.elementRef ? this.elementRef.nativeElement.childNodes : [];
    return this._getChildNodes(child_nodes).length > 0 ? true : false;
  }

  private _getChildNodes(child_nodes: any) {
    if (!child_nodes || (child_nodes && child_nodes.length === 0)) { return []; }

    const nodes = [];
    child_nodes.forEach((n) => {
      if (!(n instanceof Comment)) { nodes.push(n); }
    });

    return nodes;
  }
}
